import axios from "@/utils/AxiosInstance.js";
import moment from "moment";

const getDefaultState = () => ({
  taskSummaryData: [],
  taskSummaryDataLoadingStatus: 'notLoading',
  taskSummaryDataLoadingStatusBackground: 'notLoading',
  taskSummaryDataLoadingError: '',
  taskSummaryDataLoadingErrorStatus: false,

  taskAggSummaryData: [],
  taskAggSummaryDataLoadingStatus: [],

  userNames: [],

  coachingDefinitionsData: [],
  coachingDefinitionsDataLoadingStatus: 'notLoading',

  taskTitlesData: [],
  taskTitlesDataLoadingStatus: 'notLoading',

  scorecardsListData: [],
  scorecardsListDataLoadingStatus: 'notLoading',

  scorecardsOverridesData: [],
  scorecardsOverridesDataLoadingStatus: 'notLoading',

  scorecardsAggOverridesData: [],
  scorecardsAggOverridesDataLoadingStatus: 'notLoading',

  taskListLoadingErrorStatus: false,
  taskListLoadingError: "",
  taskListLoadingStatus: "notLoading",
  taskList: [],

  fixDateRange: {},

  taskAndGuidanceSessionCounts: [],
  taskAndGuidanceSessionCountsLoadingStatus: 'notLoading',
  taskAndGuidanceSessionCountsLoadingError: '',
  taskAndGuidanceSessionCountsLoadingErrorStatus: false,

  retrieveTaskOwnershipLoadingError: '',
  retrieveTaskOwnershipLoadingErrorStatus: false,

});

export const taskSummaryData = {
  namespaced: true,
  state: getDefaultState(),
  getters: {

    taskSummaryData: state => state.taskSummaryData,
    taskSummaryDataLoadingStatus: state => state.taskSummaryDataLoadingStatus,
    taskSummaryDataLoadingStatusBackground: state => state.taskSummaryDataLoadingStatusBackground,
    taskSummaryDataLoadingError: state => state.taskSummaryDataLoadingError,
    taskSummaryDataLoadingErrorStatus: state => state.taskSummaryDataLoadingErrorStatus,

    taskAggSummaryData: state => state.taskAggSummaryData,
    taskAggSummaryDataLoadingStatus: state => state.taskAggSummaryDataLoadingStatus,

    userNames: state => state.userNames,

    coachingDefinitionsData: state => state.coachingDefinitionsData,
    coachingDefinitionsDataLoadingStatus: state => state.coachingDefinitionsDataLoadingStatus,

    taskTitlesData: state => state.taskTitlesData,
    taskTitlesDataLoadingStatus: state => state.taskTitlesDataLoadingStatus,

    scorecardsListData: state => state.scorecardsListData,
    scorecardsListDataLoadingStatus: state => state.scorecardsListDataLoadingStatus,

    scorecardsOverridesData: state => state.scorecardsOverridesData,
    scorecardsOverridesDataLoadingStatus: state => state.scorecardsOverridesDataLoadingStatus,

    scorecardsAggOverridesData: state => state.scorecardsAggOverridesData,
    scorecardsAggOverridesDataLoadingStatus: state => state.scorecardsAggOverridesDataLoadingStatus,

    taskListLoadingErrorStatus: state => state.taskListLoadingErrorStatus,
    taskListLoadingError: state => state.taskListLoadingError,
    taskListLoadingStatus: state => state.taskListLoadingStatus,
    taskList: state => state.taskList,

    fixDateRange: state => state.fixDateRange,

    taskAndGuidanceSessionCounts: state => state.taskAndGuidanceSessionCounts,
    taskAndGuidanceSessionCountsLoadingStatus: state => state.taskAndGuidanceSessionCountsLoadingStatus,
    taskAndGuidanceSessionCountsLoadingError: state => state.taskAndGuidanceSessionCountsLoadingError,
    taskAndGuidanceSessionCountsLoadingErrorStatus: state => state.taskAndGuidanceSessionCountsLoadingErrorStatus,

    retrieveTaskOwnershipLoadingError: state => state.retrieveTaskOwnershipLoadingError,
    retrieveTaskOwnershipLoadingErrorStatus: state => state.retrieveTaskOwnershipLoadingErrorStatus,

  },
  mutations: {

    SET_FIX_DATE_RANGE(state, payload) {
      state.fixDateRange = payload;
    },

    RESET_STATE(state) {
      // merge a fresh default state back in
      Object.assign(state, getDefaultState());
    },

    SET_USERNAMES(state, names) {
      state.userNames = names;
    },

    SET_COACHING_DEFINITIONS_DATA(state, data) {
      state.coachingDefinitionsData = data;
    },
    SET_COACHING_DEFINITIONS_DATA_LOADING_STATUS(state, status) {
      state.coachingDefinitionsDataLoadingStatus = status;
    },

    SET_TASK_TITLES_DATA(state, data) {
      state.taskTitlesData = data;
    },
    SET_TASK_TITLES_DATA_LOADING_STATUS(state, status) {
      state.taskTitlesDataLoadingStatus = status;
    },

    SET_SCORECARDS_LIST_DATA(state, data) {
      state.scorecardsListData = data;
    },
    SET_SCORECARDS_LIST_DATA_LOADING_STATUS(state, status) {
      state.scorecardsListDataLoadingStatus = status;
    },

    SET_SCORECARDS_OVERRIDES_DATA(state, data) {
      state.scorecardsOverridesData = data;
    },
    SET_SCORECARDS_OVERRIDES_DATA_LOADING_STATUS(state, status) {
      state.scorecardsOverridesDataLoadingStatus = status
    },

    SET_SCORECARDS_AGG_OVERRIDES_DATA(state, data) {
      state.scorecardsAggOverridesData = data;
    },
    SET_SCORECARDS_AGG_OVERRIDES_DATA_LOADING_STATUS(state, status) {
      state.scorecardsAggOverridesDataLoadingStatus = status
    },

    SET_TASK_SUMMARY_DATA(state, data) {
      state.taskSummaryData = data
    },
    SET_TASK_SUMMARY_DATA_LOADING_STATUS(state, status) {
      state.taskSummaryDataLoadingStatus = status
    },
    SET_TASK_SUMMARY_DATA_LOADING_STATUS_BACKGROUND(state, status) {
      state.taskSummaryDataLoadingStatusBackground = status
    },
    SET_TASK_SUMMARY_DATA_LOADING_ERROR(state, status) {
      state.taskSummaryDataLoadingError = status
    },
    SET_TASK_SUMMARY_DATA_LOADING_ERROR_STATUS(state, status) {
      state.taskSummaryDataLoadingErrorStatus = status
    },

    SET_TASK_AGG_SUMMARY_DATA(state, data) {
      state.taskAggSummaryData = data
    },
    SET_TASK_AGG_SUMMARY_DATA_LOADING_STATUS(state, status) {
      state.taskAggSummaryDataLoadingStatus = status
    },

    SET_TASK_LIST(state, taskList) {
      state.taskList = taskList
    },
    SET_TASK_LIST_LOADING_ERROR_STATUS(state, status) {
      state.taskListLoadingErrorStatus = status
    },
    SET_TASK_LIST_LOADING_ERROR(state, error) {
      state.taskListLoadingError = error
    },
    SET_TASK_LIST_LOADING_STATUS(state, status) {
      state.taskListLoadingStatus = status
    },

    SET_TASK_AND_GUIDANCE_SESSION_COUNTS(state, data) {
      state.taskAndGuidanceSessionCounts = data;
    },
    SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_STATUS(state, status) {
      state.taskAndGuidanceSessionCountsLoadingStatus = status;
    },
    SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_ERROR(state, error) {
      state.taskAndGuidanceSessionCountsLoadingError = error;
    },
    SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_ERROR_STATUS(state, status) {
      state.taskAndGuidanceSessionCountsLoadingErrorStatus = status;
    },

    RETRIEVE_TASK_OWNERSHIP_LOADING_ERROR(state, error) {
      state.retrieveTaskOwnershipLoadingError = error;
    },
    RETRIEVE_TASK_OWNERSHIP_LOADING_ERROR_STATUS(state, status) {
      state.retrieveTaskOwnershipLoadingErrorStatus = status;
    }

  },
  actions: {

    setFixDateRange({ commit }, payload ) {
      commit('SET_FIX_DATE_RANGE', payload);
    },

    resetTaskSummaryData({ commit }) {
      commit('RESET_STATE');
    },

    setUserNames({ commit }, names) {
      commit("SET_USERNAMES", names);
    },

    async retrieveTaskList(context, payload) {
      const url = process.env.VUE_APP_TASKS;
      let axios_params = {};

      axios_params['type'] = (payload.hasOwnProperty("aggregate_row") && payload.aggregate_row) ? 'by_teams_and_agent' : 'by_user_and_agent'
      axios_params['team_scope'] = 1
      if(payload.hasOwnProperty('selected_user_id')) axios_params['selected_user_id'] =  payload.selected_user_id
      if(payload.hasOwnProperty('agent_id') && payload.agent_id>0) axios_params['agent_id'] =  [payload.agent_id]
      if(payload.filter_params.hasOwnProperty('coaching_definition_ids')) axios_params['coaching_definition_ids'] = payload.filter_params.coaching_definition_ids
      if(payload.filter_params.hasOwnProperty('task_title_ids')) axios_params['task_title_id'] = payload.filter_params.task_title_ids // param is just id
      if(payload.filter_params.hasOwnProperty('start_date')) axios_params['start_date'] = payload.filter_params.start_date
      if(payload.filter_params.hasOwnProperty('end_date')) axios_params['end_date'] = payload.filter_params.end_date
      if(payload.hasOwnProperty("aggregate_row") && payload.aggregate_row && payload.hasOwnProperty('agent_id') && payload.agent_id>0) axios_params['team_agent_id'] = payload.agent_id

      if(payload.loadingMask) context.commit("SET_TASK_LIST_LOADING_STATUS", "loading");

      try {
        // First call to get the task list
        const response = await axios.get(url, { params: axios_params })
        let taskList = response.data.data

        // Extract call_ids from taskList records (only if they exist)
        const callIds = [...new Set(taskList.reduce((ids, task) => {
          if (task.call_id) ids.push(task.call_id)
          return ids
        }, []))]

        // If there are any call_ids, fetch the call records (calldt)
        if (callIds.length > 0) {
          const callResponse = await axios.get(process.env.VUE_APP_CALL_RECORDS, {
            params: { call_ids: callIds, paginate: false }
          });
          const callData = callResponse.data.data

          // Merge the call record into the corresponding task (if available)
          taskList = taskList.map(task => {
            if (task.call_id) {
              const matchingCall = callData.find(call => call.id === task.call_id)
              return { ...task, call_date: moment(matchingCall.adjustedDateTime).format("YYYY-MM-DD") || null }
            }
            return task
          });
        }

        // Update the task list with the task_title
        // 1 = Call Review, 2 = General Task
        taskList = taskList.map(task => {
          task.task_title = task.task_title_id === 1 ? 'Call Review' : 'General Task'
          return task
        })

        // Commit the updated task list
        context.commit("SET_TASK_LIST", taskList)
        context.commit("SET_TASK_LIST_LOADING_STATUS", "loaded")
        context.commit("SET_TASK_LIST_LOADING_ERROR_STATUS", false)
        context.commit("SET_TASK_LIST_LOADING_ERROR", "")
      } catch (error) {
        context.commit("SET_TASK_LIST", [])
        context.commit("SET_TASK_LIST_LOADING_STATUS", "failed")
        context.commit("SET_TASK_LIST_LOADING_ERROR_STATUS", true)
        let error_message = error.message || JSON.stringify(error)
        context.commit("SET_TASK_LIST_LOADING_ERROR", 'retrieveTaskList(): ' + error_message)
      }
    },

    async retrieveTaskSummaryData({ commit }, payload) {

      let axios_summary_params = {
        params: payload.summary_params
      }

      commit("SET_TASK_SUMMARY_DATA_LOADING_STATUS_BACKGROUND", "loading");
      if(payload.loadingMask) {
        commit("SET_TASK_SUMMARY_DATA_LOADING_STATUS", "loading");
        commit("SET_COACHING_DEFINITIONS_DATA_LOADING_STATUS", "loading");
        commit("SET_TASK_TITLES_DATA_LOADING_STATUS", "loading");
      }

      try {
        const [responseDefs, responseSummaryData] = await Promise.all([
          axios.get(process.env.VUE_APP_COACHING_DEFINITIONS + '?definition_scope=1'),
          axios.get(process.env.VUE_APP_TASK_SUMMARY_AGGREGATES, axios_summary_params),
        ]);

        commit("SET_COACHING_DEFINITIONS_DATA", responseDefs.data.definitions);
        commit("SET_COACHING_DEFINITIONS_DATA_LOADING_STATUS", "loaded");

        const taskTitles = [
          { title: 'Call Review', title_id: 1 },
          { title: 'General Task', title_id: 2 }
        ];
        commit("SET_TASK_TITLES_DATA", taskTitles);
        commit("SET_TASK_TITLES_DATA_LOADING_STATUS", "loaded");

        const uniqueScorecardIds = [
          ...new Set(
              responseDefs.data.definitions.flatMap(item =>
                  item.scorecards.map(card => card.scorecard_id)
              )
          )
        ];

        let axios_associates_params = {
          params: {type: "accessroles", scorecard_ids: uniqueScorecardIds}
        }
        let axios_overrides_params = {
          params: {start_date: payload.summary_params.start_date, end_date: payload.summary_params.end_date, scorecard_ids: uniqueScorecardIds}
        }

        let axios_agg_user_params = Object.assign({}, {params: payload.summary_params});
        axios_agg_user_params.params.aggregate_users = 1
        axios_agg_user_params.params.scorecard_ids = uniqueScorecardIds

        // the requests below rely on the requests above to have completed
        const [responseAggOverrides, responseSummaryAggData, responseAssociates, responseOverrides] = await Promise.all([
          axios.get(process.env.VUE_APP_SCORECARDS_V2_OVERRIDES, axios_agg_user_params),
          axios.get(process.env.VUE_APP_TASK_SUMMARY_AGGREGATES, axios_agg_user_params),
          axios.get(process.env.VUE_APP_SCORECARDS_V2_ASSOCIATES, axios_associates_params),
          axios.get(process.env.VUE_APP_SCORECARDS_V2_OVERRIDES, axios_overrides_params)
        ]);

        commit("SET_SCORECARDS_LIST_DATA", responseAssociates.data.data);
        commit("SET_SCORECARDS_LIST_DATA_LOADING_STATUS", "loaded");
        commit("SET_SCORECARDS_OVERRIDES_DATA", responseOverrides.data.data);
        commit("SET_SCORECARDS_OVERRIDES_DATA_LOADING_STATUS", "loaded");
        commit("SET_TASK_SUMMARY_DATA_LOADING_STATUS_BACKGROUND", "loaded");

        let aggSummData = responseSummaryAggData.data.data.aggregated_user_agents
        let aggOverrideData = responseAggOverrides.data.data.aggregated_user_agents
        aggSummData.totals.adjustments = aggOverrideData.total_adjustments
        if (Array.isArray(aggSummData.agents)) {
          for (const agent in aggSummData.agents) {
                aggSummData.agents = aggSummData.agents.map(agent => {
                // Note: summaryData agents use "id", overrides use "agent_id"
                const agentOverride = aggOverrideData.agents.find(o => o.agent_id === agent.id);
                if (agentOverride) {
                  // Add the adjustments property to the agent object.
                  return {
                    ...agent,
                    adjustments: agentOverride.adjustments
                  };
                }
                return agent;
              });
          }
        }

        commit("SET_TASK_AGG_SUMMARY_DATA", aggSummData);
        commit("SET_TASK_AGG_SUMMARY_DATA_LOADING_STATUS", "loaded");
        commit("SET_SCORECARDS_AGG_OVERRIDES_DATA", aggOverrideData);
        commit("SET_SCORECARDS_AGG_OVERRIDES_DATA_LOADING_STATUS", "loaded");

        // get the overrides in there
        let summaryData = responseSummaryData.data.data;
        const overridesData = responseOverrides.data.data;

        for (const userId in summaryData) {
          if (overridesData[userId]) {
            // Update the totals section with user-level adjustments
            if (summaryData[userId].totals) {
              summaryData[userId].totals.adjustments = overridesData[userId].total_adjustments;
            }
            // Update each agent in the agents list with its own adjustments
            if (Array.isArray(summaryData[userId].agents)) {
              summaryData[userId].agents = summaryData[userId].agents.map(agent => {
                // Note: summaryData agents use "id", overrides use "agent_id"
                const agentOverride = overridesData[userId].agents.find(o => o.agent_id === agent.id);
                if (agentOverride) {
                  // Add the adjustments property to the agent object.
                  return {
                    ...agent,
                    adjustments: agentOverride.adjustments
                  };
                }
                return agent;
              });
            }
          }
        }

        // Now commit the updated summary data with adjustments merged in.
        commit("SET_TASK_SUMMARY_DATA", summaryData);
        commit("SET_TASK_SUMMARY_DATA_LOADING_STATUS", "loaded");
        commit("SET_TASK_SUMMARY_DATA_LOADING_ERROR_STATUS", false);
        commit("SET_TASK_SUMMARY_DATA_LOADING_ERROR", "");

      } catch (error) {
        commit("SET_TASK_SUMMARY_DATA_LOADING_STATUS_BACKGROUND", "failed");
        commit("SET_TASK_SUMMARY_DATA_LOADING_STATUS", "failed");
        commit("SET_TASK_SUMMARY_DATA_LOADING_ERROR_STATUS", true);
        commit(
            "SET_TASK_SUMMARY_DATA_LOADING_ERROR",
            "retrieveTaskSummaryData(): " + JSON.stringify(error)
        );
      }
    },

    async retrieveUserTasksAndGuidanceSessionCounts(context, params) {
      let url = process.env.VUE_APP_COACHING_REASSIGN;
      if (params && params['user_ids'] && Array.isArray(params.user_ids) && params.user_ids.length > 0) {
        const query = params['user_ids'].map(id => `user_ids[]=${encodeURIComponent(id)}`).join('&');
        if (query) {
          url += `?${query}`;
        }
      }

      context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_STATUS", "loading");
      context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_ERROR_STATUS", false);
      context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_ERROR", "");
      try {
        const response = await axios.get(url);
        context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS", response.data.data);
        context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_STATUS", "loaded");
      } catch (error) {
        context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_STATUS", "failed");
        context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_ERROR_STATUS", true);
        let error_message = error.message || JSON.stringify(error);
        context.commit("SET_TASK_AND_GUIDANCE_SESSION_COUNTS_LOADING_ERROR", 'retrieveUserTasksAndGuidanceSessionCounts(): ' + error_message);
      }
    },

    async reassignTaskOwnership(context, payload) {
      const url = process.env.VUE_APP_COACHING_REASSIGN;
      const params = {
        old_user_id: payload.old_user_id,
        new_user_id: payload.new_user_id,
      };

      context.commit("RETRIEVE_TASK_OWNERSHIP_LOADING_ERROR", "");
      context.commit("RETRIEVE_TASK_OWNERSHIP_LOADING_ERROR_STATUS", false);

      try {
        await axios.post(url, params);
        // context.dispatch("retrieveTaskSummaryData", { summary_params: payload.summary_params });
      } catch (error) {
        let error_message = error.message || JSON.stringify(error);
        context.commit("RETRIEVE_TASK_OWNERSHIP_LOADING_ERROR", 'reassignTaskOwnership(): ' + error_message);
        context.commit("RETRIEVE_TASK_OWNERSHIP_LOADING_ERROR_STATUS", true);
        return false; // Indicate failure
      }
      return true; // Indicate success
    },

  },
};
